
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 33 36","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M13.364 21.091h6.182V35h-6.182zM1 28.818h6.182V35H1zM25.727 13.364h6.182V35h-6.182zM2.545 13.364l7.728-7.728 6.182 6.182L27.273 1"}}),_c('path',{attrs:{"d":"M20.318 1h6.955v6.955"}})])])
          )
        }
      }
    